import React from 'react';
import { withSuspense } from '../../components/hoc';

const NotFoundPage = React.lazy(() => import('../../pages/NotFound'));

export default withSuspense(NotFoundPage);
